import * as React from 'react';

import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import useBreakpoints from '../../../hooks/useBreakpoints';

type SideBySideProps = {
  ratio?: number;
  shouldFlexEnd?: boolean;
};

const SideBySide: React.FC<React.PropsWithChildren<SideBySideProps>> = ({
  children,
  ratio = 6,
  shouldFlexEnd = false,
}) => {
  // See the sibling copy in CreateUpdateOffer: the old 600px threshold sat
  // below the app-download gate, so it never fired.
  const { isNarrow } = useBreakpoints();

  const childs = React.Children.toArray(children);

  const ratios = React.useMemo(() => {
    if (isNarrow) {
      return [12, 12];
    }

    return [ratio, 12 - ratio];
  }, [isNarrow, ratio]);

  return (
    <Box>
      <Grid container spacing={2}>
        {React.Children.map(childs, (child, i) => (
          <Grid key={i} item xs={ratios[i]} {...(shouldFlexEnd && { alignSelf: 'flex-end' })}>
            {child}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SideBySide;
